

import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Loader from '../../../../Components/Loader';
import ModalDailog from '../../../../Components/Modal';
import RecieptIcon from '../../../../assets/images/receipt-icon.svg';
import { API_ENDPOINTS } from '../../../../utils/api';
import createAxiosInstance from "../../../../utils/axiosInstance";
import { formatDateTime, formatToUSD } from '../../../../utils/formatters';

const DonationsDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isCancelNeedModalOpen, setIsCancelNeedModalOpen] = useState(false);
  const [donation, setDonationsDetails] = useState<any>([]);
  const [isLoding, setIsLoding] = useState(true);
  const axiosInstance = createAxiosInstance();
  const { donationId } = useParams();

  const handleDonationModal = () => {
    setIsCancelNeedModalOpen(true);
  }

  const closeDonationModal = () => {
    setIsCancelNeedModalOpen(false);
  }

  useEffect(() => {
    getDonationDetails();
  }, []);

  const getDonationDetails = async () => {
    try {
      const response = await axiosInstance.get(`${API_ENDPOINTS.SAFENIIGHT.GETRECENTDONATIONS}/${donationId}?expand=need/assessments,donor&orderBy=donationDate+desc`);

      const data = response.data; // Extract the actual data

      setDonationsDetails(data);
      setIsLoding(false);
    } catch (error) {
      setIsLoding(false);
      console.log(error);
    }
  };

  const sendDonationReceipt = async () => {
    try {
      setIsLoding(true);
      const response = await axiosInstance.post(`${API_ENDPOINTS.SAFENIIGHT.SENDDONATIONRECEIPT.replace("{donationId}", donationId ?? "")}`);

      const data = response.data; // Extract the actual data

      closeDonationModal();
      setIsLoding(false);
    } catch (error) {
      setIsLoding(false);
      console.log(error);
    }
  };

  return (
    <>
      {isLoding && <Loader />}
      <div className="container py-4 md:py-10 2xl:py-[70px] flex justify-center">
        <div className="w-full xl:w-2/3">
          <div className="card mt-5 p-4 md:p-6">
            <h2 className='text-base lg:text-lg 2xl:text-2xl font-semibold'>Donation #{donation?.sequenceId}</h2>
            <div className="border border-borderGray rounded-xl overflow-hidden mt-5">
              <table className="w-full text-xs 2xl:text-sm text-left rtl:text-right text-gray-500">
                <tbody>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Donation Date
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {formatDateTime(donation?.donationDate)}
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Donor Name
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {donation?.firstName} {donation?.lastName}
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Donor Email
                    </th>
                    <td className="px-4 2xl:px-6 py-3 text-left md:w-4/6 text-primary">
                      <Link to={`mailto:${donation?.email}`}>{donation?.email}</Link>
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Donation Amount
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {formatToUSD(donation?.donationAmount)}
                    </td>
                  </tr>

                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Alert #
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      <Link to={`/safenight/needs/need-details/${donation?.need?.needId}`} className='text-primary'>
                        <div>{donation?.need?.sequenceId}</div>
                      </Link>
                    </td>
                  </tr>
                  <tr className="bg-white md:border md:border-b-borderGray">
                    <th scope="row" className="px-4 2xl:px-6 py-3 font-medium text-gray-900 border md:border-r-borderGray md:border-b-borderGray md:text-right">
                      Transaction Reference
                    </th>
                    <td className="px-4 2xl:px-6 py-3 md:text-left md:w-4/6 text-gray-700">
                      {donation?.donationRefNumber}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="flex gap-3">
              <div>
                <button type="button" className="btn btn-primary py-3 mt-4 btn-outline-gray transition-all delay-100 w-full" onClick={() => {
                  if (location.key !== "default") {
                    navigate(-1);
                  } else {
                    navigate("/safenight/donations", { replace: true });
                  }
                }}>
                  Back
                </button>
              </div>
              <button
                className="btn btn-primary py-3 mt-4"
                onClick={handleDonationModal}
              >
                Resend Donor Receipt
              </button>
            </div>
          </div>
        </div>
      </div>
      <ModalDailog isOpen={isCancelNeedModalOpen} onClose={closeDonationModal} title="Resend Donor Receipt" modalClassName="md:max-w-md lg:max-w-lg" isFooterAvailable={false}>
        <div className="flex flex-col text-center items-center">
          <p className='text-gray-700 font-semibold text-lg 2xl:text-xl mt-4 mb-2'>Are you sure?</p>
          <p className='text-gray-500 text-sm 2xl:text-base mb-6 font-medium'>Are you sure you want to resend donor receipt?</p>
          <div className="flex justify-center gap-3 items-center">
            <button className="btn btn-outline-gray py-2" type="submit">
              Cancel
            </button>
            <button className="btn btn-primary text-white h-10" type="button" onClick={sendDonationReceipt}>
              Yes, I’m Sure
            </button>
          </div>
        </div>
      </ModalDailog>
    </>
  )
}

export default DonationsDetails